import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-gif",
  "use": "icon-gif-usage",
  "viewBox": "0 0 1025 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1025 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-gif\"><defs><style type=\"text/css\"></style></defs><path d=\"M140.288 418.816c38.912 0 71.68-13.312 99.328-40.96 27.648-27.648 40.96-60.416 40.96-99.328 0-38.912-13.312-71.68-40.96-99.328-27.648-27.648-60.416-40.96-99.328-40.96-38.912 0-71.68 13.312-99.328 40.96-27.648 27.648-40.96 60.416-40.96 99.328 0 38.912 13.312 71.68 40.96 99.328 27.648 27.648 60.416 40.96 99.328 40.96z m209.92 209.92L233.472 512 1.024 744.448v139.264h1024V558.08L722.944 256 350.208 628.736z\" fill=\"#E89131\" p-id=\"5353\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/gif.svg
// module id = 4DYT
// module chunks = 77